import React from 'react';
import { Link } from 'react-router-dom';
import { resolveAsset } from '../api/client';
import { useLocalField } from '../i18n';

export default function CategoryTile({ category, parentSlug }) {
  const lf = useLocalField();
  const path = parentSlug ? `/c/${parentSlug}/${category.slug}` : `/c/${category.slug}`;
  return (
    <Link to={path} className="category-tile">
      {category.heroImageUrl ? (
        <img src={resolveAsset(category.heroImageUrl)} alt={lf(category, 'nameAr')} className="category-tile-image" />
      ) : (
        <div className="category-tile-placeholder" />
      )}
      <div className="category-tile-overlay">
        <h3 className="category-tile-name">{lf(category, 'nameAr')}</h3>
      </div>
    </Link>
  );
}
